export default {
  reference_number: "Ref.-Nr",
  article_number: "Art.-Nr.",
  hrs: "hrs",
  mins: "mins",
  hr: "hr",
  min: "min",
};
